import React from 'react';
import { observer } from 'mobx-react';
// import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Config
import { config } from '../../config';

// Components
import * as icons from '../Icons/Icons';

const Help = observer(class Help extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleClick = this.handleClick.bind(this);
    this.renderArticles = this.renderArticles.bind(this);
    this.toggleLinks = this.toggleLinks.bind(this);
    this.handleContentKeydown = this.handleContentKeydown.bind(this);
  }

  componentWillMount() {
    this.state = {
      collapsed: true,
      docs: [],
      feature: null
    };
  }

  componentDidMount() {
    const _this = this;
    const { HelpStore } = this.props.store;

    document.addEventListener('click', this.handleClick);

    // Make sure docs are retreived and then set the state
    const helpDelay = setInterval(function(){
      if(HelpStore.helpLoaded) {
        _this.renderArticles();
        clearInterval(helpDelay);
      }
    }, 100);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  handleClick(e) {
    const help = document.querySelector('.help');
    const helpBtn = document.querySelector('.help-wrap > button');

    let target = e.target;
    let collapsed = true;

    while(target.parentNode) {
      if(target === help || target === helpBtn) {
        collapsed = false;
        return true;
      }

      target = target.parentNode;
    }

    this.setState({
      collapsed
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const thisFeature = this.state.feature;
    const nextFeature = nextProps.store.HelpStore.feature;

    if(thisFeature !== nextFeature) {
      this.renderArticles()
    }

    return true;
  }

  componentDidUpdate() {
    if (!this.state.collapsed) { 
      const articles = document.getElementById('help__list').querySelectorAll('#help-articles');
      const helpArticles = [...articles];

      helpArticles[0].focus();
    }
  }

  renderArticles() {
    const { SessionStore, HelpStore } = this.props.store;
    const { feature } = HelpStore;
    const role = SessionStore.userData.role.toLowerCase();
    let docs = [];

    // // Get the docs for the current feature
    // if(HelpStore.help && HelpStore.help[role]) {
    //   HelpStore.help[role].forEach(article => {
    //     if(article.features.indexOf(feature) > -1) {
    //       docs.push(article);
    //     }
    //   })
    // }

    // Get the docs for the current feature
    if(HelpStore.help && HelpStore.help[feature] && HelpStore.help[feature][role]) {
      docs = HelpStore.help[feature][role];
    }

    this.setState({
      docs,
      feature
    });
  }

  toggleLinks() {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }

  handleContentKeydown(e) {
    const { setHelpDropdown } = this.props;
    const articles = document.getElementById('help__list').querySelectorAll('#help-articles');
    const helpArticles = [...articles];
    let index = Array.prototype.indexOf.call(helpArticles, e.target);

    switch (e.key) {
      case 'ArrowDown':
        if (e.target === helpArticles[helpArticles.length - 1]) {
          e.preventDefault();
          helpArticles[0].focus();
        } else {
          e.preventDefault();
          helpArticles[index + 1].focus();
        }
        break;
      case 'ArrowUp':
        if (e.target === helpArticles[0]) {
          e.preventDefault();
          helpArticles[helpArticles.length - 1].focus();
        } else {
          e.preventDefault();
          helpArticles[index - 1].focus();
        }
        break;
      case 'Escape':
        e.preventDefault();
        setHelpDropdown(false);
        this.toggleLinks();
        this.dropdownBtn.focus();
        break;
      case 'Tab':
        setHelpDropdown(false);
        this.toggleLinks();
        this.dropdownBtn.focus();
        break;
      default:
        break;
    }
  }

  render() {
    const { translation } = this.props;
    // const { userData } = this.props.store.SessionStore;

    // Get the docs for the current feature
    // if(HelpStore.help[feature] && HelpStore.help[feature][role]) {
    //   docs = HelpStore.help[feature][role];
    // }

    return (
      <div className="help-wrap">
        <button
          className={this.props.btnClass ? this.props.btnClass : ''}
          onClick={this.toggleLinks}
          id="help"
          ref={(button) => this.dropdownBtn = button}
        >
          <icons.iconQuestion />
          {translation.help}
        </button>

        <aside
          className={`help ${this.state.collapsed ? 'help--collapsed' : ''}`}
        >
          {this.state.docs.length > 0 &&
            <h5 className="help__title">{translation.articles}</h5>
          }

          {this.state.docs.length > 0 &&
            <ul className="help__list" id="help__list">
              {this.state.docs.map(
                (doc, i) =>
                <li key={i}>
                  <a
                    className="article"
                    id="help-articles"
                    target="_blank"
                    href={
                      `${doc.url.indexOf('http') < 0 ? config.docsDomain : ''}${doc.url}`
                    }
                    onKeyDown={this.handleContentKeydown}
                  >
                    <icons.iconInfo />
                    {doc.title}
                  </a>
                </li>
              )}
            </ul>
          }
        </aside>
      </div>
    );
  }
})

export default translate('Help')(Help);



// WEBPACK FOOTER //
// ./src/app/components/Help/Help.js